class BxfTypeAheadConstants {
    static COMPONENT_NAME = 'bxf-type-ahead';
    static STRING = {
        CONTAINER: 'bxf-type-ahead__container',
        OPTION_HIGHLIGHT: 'bxf-type-ahead__option-highlight',
        OPTION_HIGHLIGHT_CONTAINER: 'bxf-type-ahead__option-highlight-container',
        OPTION: 'bxf-type-ahead__option',
        OPTION_COMPACT: 'bxf-type-ahead__option--compact',
        OPTION_HOVER: 'bxf-type-ahead__option--hover',
        OPTION_GROUP: 'bxf-type-ahead__option-group',
        CATEGORISED_GROUPED_OPTION_GROUP: 'bxf-type-ahead__categorised-grouped-option-group',
        CATEGORISED_TABLE: 'bxf-type-ahead__categorised-table',
        CATEGORISED_TABLE_DROPDOWN_CONTENT: 'bxf-type-ahead__categorised-table-dropdown-content',
        OPTION_GROUP_LABEL: 'bxf-type-ahead__option-group-label',
        OPTION_GROUP_LABEL_COMPACT: 'bxf-type-ahead__option-group-label--compact',
        GROUPED_VIEW_ALL: 'bxf-type-ahead__grouped-view-all',
        GROUPED_VIEW_ALL_COMPACT: 'bxf-type-ahead__grouped-view-all--compact',
        INFO_ADD_BUTTON: 'bxf-type-ahead__info-add-button',
        INFO_ADD_BUTTON_SMALL: 'bxf-type-ahead__info-add-button-small',
        INFO_ADD_BUTTON_LARGE: 'bxf-type-ahead__info-add-button-large',
        INFO_ADD_BUTTON_PRIME: 'bxf-type-ahead__info-add-button-prime',
        INFO_ADD_BUTTON_PRIME_SMALL: 'bxf-type-ahead__info-add-button-prime--small',
        INFO_ADD_BUTTON_PRIME_LARGE: 'bxf-type-ahead__info-add-button-prime--large',
        INFO_ADD_BUTTON_PRIME_BORDER: 'bxf-type-ahead__info-add-button-prime-border',
        INFO_CONTAINER: 'bxf-type-ahead__info-container',
        INFO: 'bxf-type-ahead__info',
        INFO_TEXT_CONTAINER: 'bxf-type-ahead__info-text-container',
        INFO_TEXT: 'bxf-type-ahead__info-text',
        INFO_ADD_BUTTON_TEXT: 'bxf-type-ahead__info-add-button-text',
        INPUT_CONTAINER: 'bxf-type-ahead__input-container',
        INPUT: 'bxf-type-ahead__input',
        PILLBOX: 'bxf-type-ahead__pillbox',
        PILLBOX_SMALL: 'bxf-type-ahead__pillbox-small',
        PILLBOX_LARGE: 'bxf-type-ahead__pillbox-large',
        PILLBOX_HIDDEN: 'bxf-type-ahead__pillbox--hidden',
        PILLBOX_ALWAYS_VISIBLE: 'bxf-type-ahead__pillbox-always-visible',
        DROPDOWN: 'bxf-type-ahead__dropdown',
        DROPDOWN_CONTENT: 'bxf-type-ahead__dropdown-content',
        TABLE: 'bxf-type-ahead__table',
        TABLE_ROW: 'bxf-type-ahead__table-row',
        TABLE_CELL: 'bxf-type-ahead__table-cell',
        TABLE_CELL_COMPACT: 'bxf-type-ahead__table-cell--compact',
        TABLE_HEADER_CELL: 'bxf-type-ahead__table-header-cell',
        TABLE_HEADER_CELL_COMPACT: 'bxf-type-ahead__table-header-cell--compact',
        TABLE_FOOTER: 'bxf-type-ahead__table-footer',
        INITIAL_STATE: 'bxf-type-ahead__initial-state',
        LOADING: 'bxf-type-ahead__loading',
        ERROR_MESSAGE: 'bxf-type-ahead__message--error',
        WARNING_MESSAGE: 'bxf-type-ahead__message--warning',
        ADD_BUTTON_DEFAULT_LABEL: 'Add',
    };
    static EVENTS = {
        INPUT_VALUE_CHANGED: 'inputValueChanged',
        VALUE_CHANGED: 'typeaheadValueChanged',
        SELECTION_CHANGED: 'typeaheadSelectionChanged',
        VIEW_ALL_CLICKED: 'viewAllClicked',
        ADD_CLICKED: 'addClicked',
    };
}

export { BxfTypeAheadConstants as B };
